module.exports = __webpack_public_path__ + "img/会员专属头像.412498dc.png";